module.exports = __webpack_public_path__ + "img/Index2.b1e25bfd.png";